import { graphql } from 'gql';

export const getCatalogTypesGql = graphql(`
    query catalogTypes($where: CatalogTypeDataFilterInput, $order: [CatalogTypeDataSortInput!]) {
        catalogTypes(where: $where, order: $order) {
            uniqueId
            name
            methodologies
            allowMultiple
            canCreate
        }
    }
`);

export const createCatalogGql = graphql(`
    mutation createCatalog($catalogInput: CatalogCreateInput!) {
        createCatalog(catalogInput: $catalogInput) {
            data {
                uniqueId
                type {
                    uniqueId
                }
            }
            result
            message
            buttonText
            hasValidation
            hideValidation
            validation {
                property
                message
            }
        }
    }
`);
